import theme from "../../themes/theme";
import type { DSPOrderStatus, OrderStatusFilterValue } from "../types/m3Types";

export type OrderStatusOption = {
   value: OrderStatusFilterValue;
   label: string;
   statuses: DSPOrderStatus[];
};

export const legacyOrderStatusOptions: OrderStatusOption[] = [
   { value: "", label: "Alle", statuses: [] },
   {
      value: "RECEIVED",
      label: `Mottatt hos ${theme.storeCompanyName}`,
      statuses: ["ORDER_RECEIVED", "ORDER_CONFIRMED"]
   },
   { value: "PICKED", label: "Plukket", statuses: ["ORDER_UNDER_PICKING"] },
   { value: "PACKED", label: "Ferdig pakket", statuses: ["ORDER_PACKED"] },
   {
      value: "INVOICED",
      label: "Fakturert",
      statuses: ["ORDER_PACKED_AND_INVOICED", "ORDER_INVOICED_WITH_DEFICIENCY"]
   },
   { value: "DELETED", label: "Slettet", statuses: ["ORDER_DELETED"] }
];

export const newOrderStatusOptions: OrderStatusOption[] = [
   { value: "", label: "Alle", statuses: [] },
   {
      value: "DEVIATION",
      label: "Ordre med avvik",
      statuses: ["ORDER_INVOICED_WITH_DEFICIENCY", "ORDER_CANNOT_BE_DELIVERED"]
   },
   { value: "DELETED", label: "Ordre slettet", statuses: ["ORDER_DELETED"] }
];

export const getOrderStatusOptions = (isNewOrderFlowEnabled: boolean): OrderStatusOption[] =>
   isNewOrderFlowEnabled ? newOrderStatusOptions : legacyOrderStatusOptions;
